import moment from "moment"

export default (inputValue: string) => {
  return inputValue ? moment(inputValue).format('DD-MM-YYYY') : '-'
}